import videojs from 'video.js';
import './image-link-component.js';

const defaults = {
	images: [],
	href: '',
	title: ''
};

class ImageLinkPlugin extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player, videojs.mergeOptions(defaults, options));
		player.on('ready', () => {
			player.addClass('vjs-image-link-plugin');
			player.getChild('ControlBar').addChild('imageLinkComponent', videojs.mergeOptions(defaults, options), player.getChild('ControlBar').children().length - 2);
		});
	}
}

videojs.registerPlugin('imageLink', ImageLinkPlugin);
